import { motion } from "framer-motion";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { COMPANY, DISCLAIMERS, DISCLAIMER_INTRO } from "@/data/content";

export const Contact = () => {
  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="border-t border-epic-line bg-epic-bg"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-28 md:py-44">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="font-mono text-[11px] uppercase tracking-[0.25em] text-epic-sub mb-10"
        >
          [ 08 ] — Let's Talk
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-grotesk font-black uppercase tracking-tighter text-epic-text leading-[0.85]"
          style={{ fontSize: "clamp(3rem, 13vw, 11rem)" }}
        >
          Let's<br />
          <span className="text-epic-accent">Build</span> This.
        </motion.h2>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-2 gap-10 items-end">
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <a
              href={COMPANY.meetingUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-book-meeting"
              className="group inline-flex items-center gap-3 bg-epic-accent px-8 py-5 text-white font-mono text-xs uppercase tracking-[0.15em] transition-[background-color,transform] duration-300 hover:bg-epic-accentHover active:scale-95"
            >
              Book a Meeting
              <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={`mailto:${COMPANY.email}`}
              data-testid="contact-email"
              className="group inline-flex items-center gap-3 border border-epic-line px-8 py-5 text-epic-text font-mono text-xs uppercase tracking-[0.15em] transition-colors duration-300 hover:border-epic-lineHover"
            >
              <Mail className="w-4 h-4" />
              {COMPANY.email}
            </a>
            <a
              href="tel:8557773742"
              data-testid="contact-phone"
              className="group inline-flex items-center gap-3 border border-epic-line px-8 py-5 text-epic-text font-mono text-xs uppercase tracking-[0.15em] transition-colors duration-300 hover:border-epic-lineHover"
            >
              <Phone className="w-4 h-4" />
              {COMPANY.phone}
            </a>
          </div>

          <div className="md:text-right">
            <p className="font-grotesk font-black text-3xl tracking-tighter text-epic-text">
              {COMPANY.contactName}
            </p>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-epic-sub mt-2">
              {COMPANY.contactRole} · {COMPANY.name}
            </p>
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-epic-accent mt-1">
              {COMPANY.round} · Raising {COMPANY.raise}
            </p>
            <a
              href={COMPANY.website}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-website"
              className="inline-block font-mono text-[11px] uppercase tracking-[0.2em] text-epic-sub mt-3 transition-colors duration-300 hover:text-epic-text"
            >
              epicservicescompany.com ↗
            </a>
          </div>
        </div>

        {/* Legal disclaimers */}
        <div className="mt-24 pt-10 border-t border-epic-line">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-epic-sub mb-6">
            Forward-Looking Statements & Risk Factors
          </p>
          <p className="font-mono text-[11px] leading-relaxed text-epic-sub/70 max-w-4xl mb-6">
            {DISCLAIMER_INTRO}
          </p>
          <div className="space-y-3 max-w-4xl">
            {DISCLAIMERS.map((d, i) => (
              <p key={i} className="font-mono text-[11px] leading-relaxed text-epic-sub/70">
                {d}
              </p>
            ))}
          </div>
          <p className="font-mono text-[11px] text-epic-sub/50 mt-10">
            © {new Date().getFullYear()} {COMPANY.legalName} All rights reserved. Confidential.
          </p>
        </div>
      </div>
    </footer>
  );
};
